import {
  Module,
  getModule,
  VuexModule,
  Mutation,
  Action,
} from "vuex-module-decorators";

import {
  PanelConfig,
  parseConfigData,
  getFallbackConfig,
} from "../../data/models/PanelConfig";
import { storage } from "../../main";

const name = "panelConfig";

import store from "@/store";

if (store.state[name]) {
  store.unregisterModule(name);
}

@Module({ dynamic: true, namespaced: true, store, name: name })
export class PanelConfigVuexModule extends VuexModule {
  configCache = new Map<string, PanelConfig>();

  @Mutation
  setConfig(config: PanelConfig) {
    this.configCache.set(config.title, config);
  }

  @Action
  async loadConfig(title: string) {
    const cachedConfig = this.configCache.get(title);

    if (cachedConfig) {
      return cachedConfig;
    }

    try {
      const downloadUrl = await storage
        .ref(`/configs/${title}`)
        .getDownloadURL();

      const result = await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = "json";
        xhr.onerror = (e) => {
          reject(e);
        };
        xhr.onload = function() {
          if (this.status >= 200 && this.status < 400) {
            resolve(parseConfigData(this.response));
          } else {
            reject(this.status);
          }
        };
        xhr.open("GET", downloadUrl, true);
        xhr.send();
      });

      const config = result as PanelConfig;

      this.setConfig(config);

      return config;
    } catch (error) {
      return getFallbackConfig();
    }
  }
}

export const PanelConfigModule = getModule(PanelConfigVuexModule);
